
import moment from "moment";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import ButtonIcon from "./buttonIcon";

import { Common } from "../../services/Common";

const DatePickerIcon = (props: any) => {
  let dateSelected = ((props.date) ? props.date : null);
  let showDates = props.showDates ?? [];
  let lang = props.lang ?? '';

  const filterDate = (date: Date) => {
    return Common.filterDate(date, showDates);
  }

  return (
    <>
      <div className="SelectBox DatePickerInput Icon">
        <DatePicker
          dateFormat='dd-MM-yyyy'
          filterDate={filterDate}
          selected={dateSelected}
          onChange={(date: Date) => props.handleChange(moment(date).format("YYYY-MM-DD"))}
        />
        <ButtonIcon icon="calendar_month" />
      </div>
    </>
  )
}
export default DatePickerIcon